<script setup lang="ts">
import { VacancyType } from '#imports'

definePageMeta({
  isPublic: true,
})

const { t } = useI18n({
  useScope: 'local',
})

usePageTitle(computed(() => t('pageTitle')))
</script>

<template>
  <div>
    <PageTitle class="mb-4">
      {{ t('pageTitle') }}
    </PageTitle>
    <VacancySearch :overview-type="VacancyType.Volunteering" />
  </div>
</template>

<i18n lang="json">
{
  "en": {
    "pageTitle": "Vacancy search"
  },
  "nl": {
    "pageTitle": "Vacaturebank"
  }
}
</i18n>
